module.exports = __webpack_public_path__ + "img/activity_other7.77ddf75b.jpg";